export default __webpack_public_path__ + "static/media/ghg.eb519e30.png";